import script from "./Input.vue?vue&type=script&setup=true&lang=js"
export * from "./Input.vue?vue&type=script&setup=true&lang=js"

import "./Input.vue?vue&type=style&index=0&id=47574d2f&scoped=true&lang=css"

import exportComponent from "/home/jon/Work/ldpos-wallet/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47574d2f"]])

export default __exports__